import React, { useState, Fragment, useEffect, useRef } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  Card
} from 'reactstrap';
import Switch from 'rc-switch';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import fieldsListData from '../../../../../data/visitorFieldsList.json';
import ReactQuill from 'react-quill';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_Ingetration } from '../../../../../constants/APIs';

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
];
export function VisitorFormSettings({
  visible,
  toggle,
  formLabel,
  submit,
  handleLanguageSubmit,
  visitorData,
  integrationLanguages,
  languagevisitor,
  locale,
  isSuperAdmin,
}) {
  // console.log(nudgeData);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLang, setSelectedLang] = useState(locale);
  const [updateVisitorData, setUpdateVisitorData] = useState({});
  const [fieldList, setFieldList] = useState([]);
  const [languageVisitorData, setLangaugeVisitorData] = useState([]);
  const [ssoIntegrations, setSsoIntegrations] = useState([]);

  useEffect(() => {
    console.log('visitorData', visitorData);
    if (visitorData) {
      setUpdateVisitorData((prev) => ({
        ...prev,
        title: visitorData.title,
        buttonText: visitorData.buttonText,
        fields: visitorData.fields,
        enabled: visitorData.enabled,
        subTitle: visitorData.subTitle,
        checkboxText: visitorData.checkboxText,
        preChatType: visitorData.preChatType,
        ssoIntegrationId: visitorData.ssoIntegrationId,
      }));

      const check = visitorData.fields.some((r) => r.field === 'Name');

      const dataValues = fieldsListData.data.map((elem) => {
        const updatedElem = {
          ...elem,
          on_off: false,
          required: false,
          isEnabled: true,
        };

        if (visitorData.fields) {
          visitorData.fields.forEach((r) => {
            if (r.field === updatedElem.id) {
              updatedElem.placeHolder = r.placeHolder ?? updatedElem.name;
              updatedElem.on_off = !!r.mandatory;
              updatedElem.required = true;
            }
          });

          if (
            check &&
            (updatedElem.id === 'LastName' || updatedElem.id === 'FirstName')
          ) {
            updatedElem.isEnabled = false;
          }

          if (!check && updatedElem.id === 'Name') {
            updatedElem.isEnabled = false;
          }
        }

        return updatedElem;
      });

      setFieldList(dataValues);
    } else {
      setUpdateVisitorData((prev) => ({
        ...prev,
        title: 'Welcome to Hotel',
        buttonText: 'Start Conversation',
        subTitle:
          'Please leave your contact details to make sure we can get back in case you still have unanswered questions',
        fields: [],
        enabled: false,
        checkboxText:
          'I want to receive offers or promotions from the hotel by email or text messages.',
        preChatType: 'Form',
        ssoIntegrationId: '',
      }));

      const defaultFields = fieldsListData.data.map((elem) => ({
        ...elem,
        on_off: false,
        isEnabled: true,
        required: false,
        placeHolder: elem.name,
      }));

      setFieldList(defaultFields);
    }

    const loadIntegrations = async () => {
      const items = await fetchSSOIntegrations();
      setSsoIntegrations(items);
    };
    loadIntegrations();
    if (languagevisitor && languagevisitor.length > 0) {
      setLangaugeVisitorData(languagevisitor);
    }
  }, [visitorData, languagevisitor]);

  const fetchSSOIntegrations = async () => {
    const groupId = getGroupID();
    const channel = 'Azure';

    try {
      const res = await AxiosAPI({
        method: 'post',
        url: `${API_Ingetration}?group_id=${groupId}`,
        data: { Channels: [channel] },
      });

      return res.data.map((i) => ({
        label: i.name,
        value: String(i.id),
      }));
    } catch (e) {
      console.error('PMS Integration error:', e);
      return [];
    }
  };

  const LoadVisitorByLanguage = (lang) => {
    setIsLoading(true);
    if (lang === 'en' && visitorData !== null && visitorData !== undefined) {
      var body = {
        title: visitorData.title,
        buttonText: visitorData.buttonText,
        fields: visitorData.fields,
        enabled: visitorData.enabled,
        subTitle: visitorData.subTitle,
        checkboxText: visitorData.checkboxText,
        preChatType: visitorData.preChatType,
        ssoIntegrationId: visitorData.ssoIntegrationId,
      };
      setUpdateVisitorData(body);
      let check = false;
      visitorData.fields.forEach((r) => {
        if (r.field === 'Name') {
          check = true;
        }
      });
      let dataValues = fieldsListData.data.map((elem) => {
        elem.on_off = false;
        elem.required = false;
        elem.isEnabled = true;
        if (visitorData.fields !== null) {
          visitorData.fields.forEach((r) => {
            if (r.field === elem.id) {
              if (r.placeHolder === null) {
                elem.placeHolder = elem.name;
              } else {
                elem.placeHolder = r.placeHolder;
              }

              if (r.mandatory !== null && r.mandatory) {
                elem.on_off = true;
              } else {
                elem.on_off = false;
              }
              elem.required = true;
            }
            if (check && (elem.id === 'LastName' || elem.id === 'FirstName')) {
              elem.isEnabled = false;
            }
            if (!check && elem.id === 'Name') {
              elem.isEnabled = false;
            }
          });
        }
        return elem;
      });
      setFieldList(dataValues);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } else {
      var langvisitor = languageVisitorData.filter(
        (x) => x.languageCode === lang
      );
      if (
        langvisitor !== undefined &&
        langvisitor !== null &&
        langvisitor.length > 0
      ) {
        console.log('langvisitor', langvisitor);
        var vsisitor = langvisitor[0];
        var data = {
          title: vsisitor.title,
          buttonText: vsisitor.buttonText,
          fields: vsisitor.fields,
          subTitle: vsisitor.subTitle,
          checkboxText: vsisitor.checkboxText,
          languageCode: vsisitor.languageCode,
          preChatType: visitorData.preChatType,
          ssoIntegrationId: visitorData.ssoIntegrationId,
        };
        setUpdateVisitorData(data);
        let check = false;
        vsisitor.fields.forEach((r) => {
          if (r.field === 'Name') {
            check = true;
          }
        });
        let dataValues = fieldsListData.data.map((elem) => {
          elem.on_off = false;
          elem.required = false;
          elem.isEnabled = true;
          if (vsisitor.fields !== null) {
            vsisitor.fields.forEach((r) => {
              if (r.field === elem.id) {
                if (r.placeHolder === null) {
                  elem.placeHolder = elem.name;
                } else {
                  elem.placeHolder = r.placeHolder;
                }

                if (r.mandatory !== null && r.mandatory) {
                  elem.on_off = true;
                } else {
                  elem.on_off = false;
                }
                elem.required = true;
              }
              if (
                check &&
                (elem.id === 'LastName' || elem.id === 'FirstName')
              ) {
                elem.isEnabled = false;
              }
              if (!check && elem.id === 'Name') {
                elem.isEnabled = false;
              }
            });
          }
          return elem;
        });
        setFieldList(dataValues);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      } else {
        setUpdateVisitorData((prev) => ({
          ...prev,
          title: 'Welcome to Hotel',
          buttonText: 'Start Conversation',
          subTitle:
            'Please leave your contact details to make sure we can get back in case you still have unanswered questions',
          fields: [],
          enabled: false,
          checkboxText:
            'I want to receive offers or promotions from the hotel by email or text messages.',
          languageCode: lang,
          preChatType: 'Form',
          ssoIntegrationId: '',
        }));
        if (visitorData) {
          setUpdateVisitorData((prev) => ({
            ...prev,
            preChatType: visitorData.preChatType,
            ssoIntegrationId: visitorData.ssoIntegrationId,
          }));
        }
        setFieldList(
          fieldsListData.data.map((elem) => {
            elem.on_off = false;
            elem.isEnabled = true;
            elem.required = false;
            elem.placeHolder = elem.name;
            return elem;
          })
        );
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    }
  };

  // const handleChange = (e) => {
  //   setUpdateVisitorData({
  //     ...updateVisitorData,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateVisitorData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCheckChange = (e) => {
    if (e) {
      setUpdateVisitorData((prev) => ({
        ...prev,
        enabled: false,
      }));
    } else {
      setUpdateVisitorData((prev) => ({
        ...prev,
        enabled: true,
      }));
    }
  };
  const handleFieldChange = (e) => {
    const updatedFields = fieldList.map((elem) => {
      if (elem.name === e.name) {
        return {
          ...elem,
          on_off: !elem.on_off,
        };
      }
      return { ...elem };
    });

    setFieldList(updatedFields);

    const fieldArr = updatedFields
      .filter((m) => m.required && m.isEnabled)
      .map((m) => ({
        field: m.id,
        mandatory: !!m.on_off,
        placeHolder: m.placeHolder,
      }));

    setUpdateVisitorData((prev) => ({
      ...prev,
      fields: fieldArr,
    }));
  };
  const handleElementCheckChange = (id, enabled, checked) => {
    const updatedFields = fieldList.map((f) => {
      let updated = { ...f };

      if (f.id === id) {
        updated.required = !f.required;
      }

      if (id === 'Name' && (f.id === 'FirstName' || f.id === 'LastName')) {
        updated.isEnabled = checked;
        if (!checked) updated.required = false;
      }

      if ((id === 'FirstName' || id === 'LastName') && f.id === 'Name') {
        if (checked) {
          const counterpart = fieldList.find(
            (m) => m.id === (id === 'FirstName' ? 'LastName' : 'FirstName')
          );
          if (counterpart && !counterpart.required) {
            updated.isEnabled = true;
          }
        } else {
          updated.isEnabled = false;
          updated.required = false;
        }
      }

      return updated;
    });

    setFieldList(updatedFields);

    const fieldArr = updatedFields
      .filter((m) => m.required && m.isEnabled)
      .map((m) => ({
        field: m.id,
        mandatory: !!m.on_off,
        placeHolder: m.placeHolder,
      }));

    setUpdateVisitorData((prev) => ({
      ...prev,
      fields: fieldArr,
    }));
  };
  const handleChangePlaceholder = (event, index) => {
    const { name, value } = event.target;
    const updatedFields = fieldList.map((f, i) => {
      if (i === index && name === 'placeHolder') {
        return { ...f, placeHolder: value };
      }
      return { ...f };
    });

    setFieldList(updatedFields);

    const fieldArr = updatedFields
      .filter((m) => m.required && m.isEnabled)
      .map((m) => ({
        field: m.id,
        mandatory: !!m.on_off,
        placeHolder: m.placeHolder,
      }));

    setUpdateVisitorData((prev) => ({
      ...prev,
      fields: fieldArr,
    }));
  };

  const handleSubTitleChange = (source, data) => {
    setUpdateVisitorData((prev) => ({
      ...prev,
      subTitle: data,
    }));
  };
  const handleCheckboxTextChange = (source, data) => {
    setUpdateVisitorData((prev) => ({
      ...prev,
      checkboxText: data,
    }));
  };
  const handleIntegrationChange = (data) => {
    setUpdateVisitorData((prev) => ({
      ...prev,
      ssoIntegrationId: data,
    }));
  };
  const handleSubmit = () => {
    console.log('submit data', updateVisitorData);
    if (selectedLang === 'en') {
      submit(updateVisitorData);
    } else {
      handleLanguageSubmit(updateVisitorData);
    }
  };
  const SwitchLanguage = (e) => {
    setUpdateVisitorData(null);
    setFieldList([]);
    LoadVisitorByLanguage(e);
    setSelectedLang(e);
  };
  const styles = `
  .custom-quill .ql-toolbar.ql-snow {
    padding: 0px !important;
  }
  .custom-quill .ql-editor {
    padding: 6px 12px !important;
  }
  .custom-quill .ql-editor p {
    font-size: 12px !important;
  }
`;

  return (
    <Fragment>
      {updateVisitorData && updateVisitorData !== null && (
        <Modal isOpen={visible} toggle={toggle} size="lg" backdrop="static">
          <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
          <ModalBody>
            {/* <pre>{JSON.stringify(updateEyeCatcherNudgesData, null, 2)}</pre> */}
            <Row className="d-block align-items-center">
              <Card className="mx-4 mb-4">
                <Colxx xxs="12" className="py-3">
                  <div className="mb-2">
                    <Colxx sm={12}>
                      {updateVisitorData.preChatType !== 'SSO' && (
                        <div className="d-flex mb-2">
                          <Label>
                            <b>Enable Pre Chat Form</b>
                          </Label>
                          <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-3"
                            checked={updateVisitorData.enabled}
                            onChange={() => {
                              handleCheckChange(updateVisitorData.enabled);
                            }}
                          />
                        </div>
                      )}
                      <span>
                        Customise the messaging and the fields to appear on the Pre Chat
                        form. Pre Chat form will help you capture more contact details and
                        marketing consents. On the other hand Pre Chat form usually reduce
                        conversations volume by around 20% on average.
                      </span>
                    </Colxx>
                  </div>
                </Colxx>
              </Card>
              <Card className="mx-4 mb-4">
                <Colxx xxs="12" className="py-3">
                  <div>
                    <Colxx sm={12}>
                      <Row>
                        <LanguageTabs
                          integrationLanguages={integrationLanguages}
                          selectedTab={selectedLang}
                          setLanguage={(e) => SwitchLanguage(e)}
                        ></LanguageTabs>
                      </Row>
                    </Colxx>
                    {isLoading ? (
                      <Colxx sm={12}>
                        <div
                          className="loading"
                          style={{
                            top: 'calc(50% - 80px)',
                            left: 'calc(50% - 55px)',
                          }}
                        />
                      </Colxx>
                    ) : (
                      <Fragment>
                        <style>{styles}</style>
                        <Colxx sm={12} className="mb-3 mt-2">
                          <Label><b>
                            {updateVisitorData.preChatType === 'SSO'
                              ? 'Message'
                              : 'Title'}</b>
                          </Label>
                          <Input
                            type="text"
                            value={updateVisitorData.title || ''}
                            onChange={handleChange}
                            name="title"
                            placeholder={
                              updateVisitorData.preChatType === 'SSO'
                                ? 'Please login in order to start the conversation'
                                : ''
                            }
                          />
                        </Colxx>
                        <Colxx sm={12} className="mb-3 mt-2">
                          {/* Sub Title: hide if SSO enabled */}
                          {updateVisitorData.preChatType !== 'SSO' && (
                            <>
                              <Label><b>Sub Title</b></Label>
                              <ReactQuill
                                className="custom-quill"
                                theme="snow"
                                value={updateVisitorData?.subTitle || ''}
                                onChange={(content, delta, source) =>
                                  handleSubTitleChange(source, content)
                                }
                                modules={quillModules}
                                formats={quillFormats}
                                name="subTitle"
                              />
                            </>
                          )}
                        </Colxx>
                        <Colxx sm={12} className="mb-3  mt-2">
                          <Label><b>Button Text</b></Label>
                          <Input
                            type="text"
                            value={updateVisitorData.buttonText || ''}
                            onChange={handleChange}
                            name="buttonText"
                            placeholder={
                              updateVisitorData.sso === true ? 'Login' : ''
                            }
                          />
                        </Colxx>
                        <Colxx sm={12} className="mb-3  mt-2">
                          {/* Checkbox Text: hide if SSO enabled */}
                          {updateVisitorData.preChatType !== 'SSO' && (
                            <>
                              <Label><b>Checkbox Text</b></Label>
                              <ReactQuill
                                className="custom-quill"
                                theme="snow"
                                value={updateVisitorData.checkboxText || ''}
                                onChange={(content, delta, source) =>
                                  handleCheckboxTextChange(source, content)
                                }
                                modules={quillModules}
                                formats={quillFormats}
                                name="checkboxText"
                              />
                            </>
                          )}
                        </Colxx>
                        <Colxx sm={12} className="mt-3">
                          {/* Fields: hide if SSO enabled */}
                          {updateVisitorData.preChatType !== 'SSO' && (
                            <>
                              <div className="d-flex">
                                <Colxx sm={3} className="d-flex mb-1 p-0">
                                  <Label><b>Fields</b></Label>
                                </Colxx>
                                <Colxx sm={3} className="mb-1 text-center align-items-center d-flex justify-content-center">
                                  <Label><b>Mandatory Field</b></Label>
                                </Colxx>
                                <Colxx sm={6} className="mb-1 px-1">
                                  <Label><b>Place Holder</b></Label>
                                </Colxx>
                              </div>
                              {fieldList.map((elem, index) => (
                                <Fragment key={index}>
                                  <div className="d-flex">
                                    <Colxx sm={3} className="d-flex mb-2 p-0">
                                      <CustomInput
                                        key={index}
                                        type="checkbox"
                                        value={elem.name}
                                        id={elem.name}
                                        onChange={() => {
                                          handleElementCheckChange(
                                            elem.id,
                                            elem.isEnabled,
                                            elem.required
                                          );
                                        }}
                                        checked={elem.required}
                                        disabled={!elem.isEnabled}
                                      ></CustomInput>
                                      <span className="mt-1">{elem.name}</span>
                                    </Colxx>
                                    <Colxx sm={3} className="mb-2 text-center align-items-center d-flex justify-content-center">
                                      {elem.required ? (
                                        <Switch
                                          className="agentswitch custom-switch-primary custom-switch-small"
                                          onChange={() => {
                                            handleFieldChange(elem);
                                          }}
                                          checked={elem.on_off}
                                        />
                                      ) : null}
                                    </Colxx>
                                    <Colxx sm={6} className="mb-2 p-0">
                                      {elem.required ? (
                                        <Input
                                          type="text"
                                          value={elem.placeHolder}
                                          onChange={(e) =>
                                            handleChangePlaceholder(e, index)
                                          }
                                          name="placeHolder"
                                        />
                                      ) : null}
                                    </Colxx>
                                  </div>
                                </Fragment>
                              ))}
                            </>
                          )}
                        </Colxx>
                      </Fragment>
                    )}
                  </div>
                </Colxx>
              </Card>
              {isSuperAdmin && isSuperAdmin === true && (
                <Card className="mx-4 mt-4">
                  <Colxx xxs="12" className="p-3">
                    <div>
                      <Colxx sm={12}>
                        <Label><b>Enable SSO</b><span style={{ color: 'grey', fontSize: '12px', paddingLeft: '6px' }}>(Only visible to Super Admins)</span></Label>
                        <div
                          style={{ display: 'flex', gap: '20px', alignItems: 'center' }}
                        >
                          <CustomInput
                            type="radio"
                            id="sso-enable"
                            name="sso"
                            label="Yes"
                            checked={updateVisitorData.preChatType === 'SSO'}
                            onChange={() =>
                              setUpdateVisitorData((prev) => ({
                                ...prev,
                                preChatType: 'SSO',
                              }))
                            }
                          />
                          <CustomInput
                            type="radio"
                            id="sso-disable"
                            name="sso"
                            label="No"
                            checked={updateVisitorData.preChatType !== 'SSO'}
                            onChange={() =>
                              setUpdateVisitorData((prev) => ({
                                ...prev,
                                preChatType: 'Form',
                              }))
                            }
                          />
                        </div>
                      </Colxx>
                      {ssoIntegrations && updateVisitorData.preChatType === 'SSO' && (
                        <Colxx xxs="12">
                          <div className="mt-2">
                            <div className="d-flex align-items-center mb-2">
                              <Label className="mr-2">Integration:</Label>
                              <Input
                                type="select"
                                value={updateVisitorData.ssoIntegrationId ?? ''}
                                onChange={(e) => {
                                  handleIntegrationChange(e.target.value);
                                }}
                              >
                                <option value="">Select Integration</option>
                                {ssoIntegrations.map((i) => (
                                  <option key={i.value} value={i.value}>
                                    {i.label}
                                  </option>
                                ))}
                              </Input>
                            </div>
                          </div>
                        </Colxx>
                      )}
                      {updateVisitorData.preChatType === 'SSO' &&
                        ssoIntegrations.length === 0 && (
                          <div
                            style={{
                              color: 'red',
                              marginBottom: '15px',
                              fontWeight: 'bold',
                            }}
                          >
                            No Azure SSO integrations found. Please create an Azure
                            Integration first.
                          </div>
                        )}
                    </div>
                  </Colxx>
                </Card>
              )}
            </Row>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <Button size="xs" color="primary" onClick={handleSubmit}>
              Update
            </Button>
            <Button size="xs" color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
}
